// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__TBDnN","title":"InfoRow_title__ofKkr"};